import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';

export class SettingsButton extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      w: w => w,
      h: 116,
      color: Theme.Colors.Transparent,
      Background: {
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 14,
        },
        rect: true,
        x: 0,
        y: 8,
        w: w => w,
        h: h => h - 16,
        color: Theme.Colors.Settings.Background.Normal,
      },
      TopLine: {
        x: 20,
        y: 20,
        w: w => w - 40,
        h: h => h - 16,
        text: {
          ...Theme.Fonts.Settings.Item,
          advancedRenderer: true,
          textColor: Theme.Colors.Settings.Text,
        },
      },
      BottomLine: {
        x: 20,
        y: 60,
        w: w => w - 40,
        h: h => h - 16,
        text: {
          ...Theme.Fonts.Settings.Item,
          advancedRenderer: true,
          textColor: Theme.Colors.Settings.Text,
        },
      },
    };
  }

  /**
   * @param {SettingsButtonData} data
   */
  set data(data) {
    this._data = data;
    this.tag('TopLine').text.text = data.topLine;
    this.tag('BottomLine').text.text = data.bottomLine;
  }

  get data() {
    return this._data;
  }

  get label() {
    return this._data.topLine;
  }

  _focus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Focus);
  }

  _unfocus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Item);
  }

  _handleEnter() {
    this.signal('onActivate', this);
  }
}
